import React, { Component } from 'react'
import axios from '../../service/index'
import { Tree, Form, Modal, message, Divider, Button, Input, Select } from 'antd';
import UploadVideo from '../../commponents/video/index'
import './catalogue.less'
const { Option } = Select
const { TreeNode } = Tree;

class Catalogue extends Component {
	constructor(props) {
		super(props)
		this.state = {
			gData: [],
			expandedKeys: [],
			modalTitle: '新建章',
			sectionVisible: false,
			sectionTitle: '新建小节',
			token: '',
			url: '',
			outlineId: '',
			stageOption: [],
			courseOption: [],
			oneId: null,
			fileName: '',
			bosUrl: '',
			plainlist: [],
			catalOption: [],
			subjectIcon: '',
			statistics: '', 
			catalogVisible: false,
			selectIds: [],
			toStageId: '',
			toCourseId: '',
			toOutlineId: '',
			parentOutlineNames: '',
		};
	}
	onDragEnter = info => {
		console.log(info);
		// expandedKeys 需要受控时设置
		// this.setState({
		//   expandedKeys: info.expandedKeys,
		// });
	};
	componentDidMount() {
		this.getoutlintList()
		this.getToken()
	}
	stageList() {
		axios.post('courseController/changeOutline/getStageList', {
			subjectId: sessionStorage.getItem('subjectId'),
			courseId: sessionStorage.getItem('courseId'),
			fromOutlineIds: this.state.selectIds
		}).then(res => {
			if (res.data.code === '200') {
				let name = []
				name = res.data.data.parentOutlineNames||[]
				this.setState({
					parentOutlineNames: name.join('，')||'',
					stageOption: res.data.data.stages||[]
				})
			}
		})
	}
	stageChange = (e) => {
		this.setState({
			toStageId: e,
			toCourseId: '',
			toOutlineId: '',
			courseOption: [],
			catalOption: []
		},() => {
			this.courseList()
		})
	}
	courseList() {
		axios.post('courseController/changeOutline/getCourseList', {
			subjectId: sessionStorage.getItem('subjectId'),
			stageId: this.state.toStageId
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					courseOption: res.data.data||[]
				})
			}
		})
	}
	courseChange = (e) => {
		this.setState({
			toCourseId: e,
			toOutlineId: '',
			catalOption: []
		},() => {
			this.catalList()
		})
	}
	catalList() {
		axios.post('courseController/changeOutline/getOutlineList', {
			courseId: this.state.toCourseId,
		}).then(res => {
			if (res.data.code === '200') {
				this.setState({
					catalOption: res.data.data||[]
				})
			}
		})
	}
	getoutlintList() {
		axios.post('outlineController/getList', {
			courseId: sessionStorage.getItem('courseId')
		}).then(res => {
			if (res.data.code === '200') {
				let arr = res.data.data.list
				for (let i = 0; i < arr.length; i++) {
					arr[i].key = `${i}_${arr[i].id}`
					if (arr[i].children && arr[i].children) {
						for (let j = 0; j < arr[i].children.length; j++) {
							arr[i].children[j].key = `${i}-${j}_${arr[i].children[j].id}`
						}
					}
				}
				this.setState({
					gData: arr.slice(0),
					plainlist: res.data.data.list,
					statistics: res.data.data.msg
				})
			}
		})
	}
	onDrop = info => {
		const dropKey = info.node.props.eventKey;
		const dragKey = info.dragNode.props.eventKey;//拖拽的
		const dropPos = info.node.props.pos.split('-');
		const dropPosition = info.dropPosition - Number(dropPos[dropPos.length - 1]);
		const str1 = dropKey.split('-');
		const str2 = dragKey.split('-');
			const loop = (data, key, callback) => {
				for (let i = 0; i < data.length; i++) {
					if (data[i].key === key) {
						return callback(data[i], i, data);
					}
					if (data[i].children) {
						loop(data[i].children, key, callback);
					}
				}
			};
			let dragObj;
			let data = [...this.state.gData];
			loop(data, dragKey, (item, index, arr) => {
				arr.splice(index, 1);
				dragObj = item;
			});

			if (!info.dropToGap) {
				loop(data, dropKey, item => {
					item.children = item.children || [];
					// where to insert 示例添加到尾部，可以是随意位置
					if (item.level === dragObj.level) {
						if(dragObj.level===2){
							console.log('二级目录在节点内拖拽')
							if (str1[0] === str2[0]) {
								let flag = dragObj.key.split('-')
								data[+flag[0]].children.splice(info.dropPosition, 0, dragObj)
							}
						}else {
							//一级目录拖拽节点内
							for (let i = 0; i < data.length; i++) {
								if (data[i].id === dragObj.id) {
									return
								}
							}
							data.splice(info.dropPosition, 0, dragObj)
						}
					} else {
						this.getoutlintList()
					}
				});
			} else if (
				(info.node.props.children || []).length > 0 && // 有children
				info.node.props.expanded && // Is expanded
				dropPosition === 1 // 再底部缝隙上
			) {
				loop(data, dropKey, item => {
					item.children = item.children || [];
					// where to insert 示例添加到头部，可以是随意位置
					if (item.level === dragObj.level) {
						for (let i = 0; i < data.length; i++) {
							if (data[i].id === dragObj.id) {
								return
							}
						}
						data.splice(info.dropPosition, 0, dragObj)
					} else {
						let flag = dragObj.key.split('-')
						let splicIndex = +flag[1].split('_')[0] //index
						data[+flag[0]].children.splice(splicIndex, 0, dragObj)
					}
				});
			} else {
				let ar; // eslint-disable-line no-unused-vars
				let i;
				loop(data, dropKey, (item, index, arr) => {
					ar = arr;
					i = index;
				});
				if (dropPosition === -1) {
					if(dragObj.level === 2 ) {
						//根据dropKey的长度判断是一级目录还是二级目录
						let dropKeyLength = dropKey.split('-').length
						if (str1[0] === str2[0]&&dropKeyLength===2) {
						//('二级目录拖拽节点上方')
							let flag = dragObj.key.split('-')
							let splicIndex = +dropPos[2]
							data[+flag[0]].children.splice(splicIndex, 0, dragObj)
						}else {
							//假如拖拽到了一级目录的上方则不移动
							let flag = dragObj.key.split('-')
							let splicIndex = +flag[1]
							data[+flag[0]].children.splice(splicIndex, 0, dragObj)
						}
						
					}else {
						//一级目录拖拽节点上方
						data.splice(i,0,dragObj)
					}
				} else {
					if(dragObj.level === 2 ) {
						//二级目录拖拽节点下方
						if (str1[0] === str2[0]) {
							let flag = dragObj.key.split('-')
							data[+flag[0]].children.splice(i+1, 0, dragObj)
						}else {
							//假如拖拽到了一级目录的下方则不移动
							let flag = dragObj.key.split('-')
							let splicIndex = +flag[1]
							data[+flag[0]].children.splice(splicIndex, 0, dragObj)
						}
					}else {
						//一级目录拖拽节点下方或者tuo
						data.splice(i+1,0,dragObj)
					}
				}
			}
			this.setState({
				gData: data,
			},()=>{
				this.outlineListUpdata()
			});
	};
	outlineListUpdata(){
		let arr = this.state.gData
		let list = []
		for(let i = 0; i<arr.length; i++){
			let id = {
				id: arr[i].id,
				children: []
			}
			list.push(id)
			if(arr[i].children&&arr[i].children){
				for(let j = 0; j<arr[i].children.length; j++){
					let child= {
						id: arr[i].children[j].id
					}
					list[i].children.push(child)
				}
			}
		}
		axios.post('outlineController/updateSort',{
			list: list
		}).then( res => {
			if(res.data.code === '200'){
				this.getoutlintList()
			}else {
				message.error(res.data.msg)
			}
			
		})
	}
	
	handleOk = (e) => {
		let _this = this
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (this.state.modalTitle === '新建章') {
					axios.post('/outlineController/add', {
						name: values.name,
						courseId: sessionStorage.getItem('courseId'),
						parentId: '0'
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加章成功')
							this.props.form.resetFields();
							this.setState({ visible: false })
							this.getoutlintList()
						} else {
							message.error(res.data.msg)
						}
					})
				} else {
					axios.post('outlineController/update', {
						id: this.state.oneId,
						name: values.name,
					}).then(res => {
						if (res.data.code === '200') {
							message.success('修改章名称成功')
							_this.props.form.resetFields();
							_this.setState({ visible: false })
							_this.getoutlintList()
						} else {
							message.error(res.data.msg)
						}
					})
				}

			}

		});
	}
	updateBatch() {
		this.stageList()
		this.setState({ catalogVisible: true })
	}
	onCheck = (checkedKeys, info) => {
		let selectKey = []
		for (let i = 0; i < checkedKeys.length; i++) {
			let flag = checkedKeys[i].split('_')
			if(flag[0].indexOf('-')>-1&&flag[1])
			selectKey.push(flag[1])
		}
		this.setState({
			selectIds: selectKey
		})
  };
	submitOk() {
		this.props.form.validateFields((err, values) => {
			if (!err) {
				axios.post('/courseController/changeOutline/save', {
					fromOutlineIds: this.state.selectIds,
					toStageId: values.toStageId, 
					toCourseId:values.toCourseId,
					toOutlineId:values.toOutlineId
				}).then(res => {
					if (res.data.code === '200') {
						this.setState({
							selectIds: [],
							catalogVisible: false,
						})
						message.success('小节移动成功')
						this.props.form.resetFields();
						this.getoutlintList()
					}
				})
			}
		})
	}
	section(item) {
		this.setState({ sectionVisible: true, oneId: item.id, sectionTitle: '新建小节', subjectIcon: '' })
	}
	sectionOK(item) {
		let _this = this
		this.props.form.validateFields((err, values) => {
			if (!err) {
				if (this.state.sectionTitle === '新建小节') {
					axios.post('/outlineController/add', {
						name: values.name,
						courseId: sessionStorage.getItem('courseId'),
						boskey: !values.attachments||!values.attachments[0].response?'':values.attachments[0].response.key,
						bosUrl: !values.attachments?'':values.attachments&&values.attachments[0].md5Code?values.attachments[0].url:_this.state.url + '/' + values.attachments[0].response.key,
						zmbosUrl: !values.attachments?'':values.attachments[0].zmBosUrl?_this.state.url + '/'+values.attachments[0].zmBosUrl:values.attachments[0].response.zmBosUrl?_this.state.url + '/'+values.attachments[0].response.zmBosUrl:'',
						md5Code: values.attachments&&values.attachments[0].md5Code?values.attachments[0].md5Code: '',
						parentId: _this.state.oneId,
						fileName: !values.attachments?'':values.attachments[0].name,
						persistentId: values.attachments&&values.attachments[0].type&&values.attachments[0].type.split('/')[1] !== 'mp4'? values.attachments[0].response.persistentId : '',
						uploadUid: values.attachments&&values.attachments[0].uid?values.attachments[0].uid: '',
						uploadType: values.attachments&&values.attachments[0].type?values.attachments[0].type: ''
					}).then(res => {
						if (res.data.code === '200') {
							message.success('添加小节成功')
							this.props.form.resetFields();
							this.setState({ sectionVisible: false })
							this.getoutlintList()
						} else {
							message.error(res.data.msg)
						}
					})
						.catch(e => {
							console.log(e)
						})
				} else {
					let pic
					let fileName
					let persistentId
					let params
					console.log(values)
					if(values.attachments.length>0||Object.keys(values.attachments).length>0){
						console.log(111)
						pic = values.attachments && values.attachments.url ? values.attachments.url : values.attachments&&values.attachments[0].md5Code?values.attachments[0].url:this.state.url + '/' + values.attachments[0].response.key
						fileName = values.attachments && values.attachments.name ? values.attachments.name : values.attachments[0].name
						if(!values.attachments){
							persistentId= ''
						}
						if(values.attachments instanceof Array){
							persistentId = values.attachments[0].type&&values.attachments[0].type.split('/')[1] !== 'mp4'?values.attachments[0].response.persistentId: ''
						}else {
							persistentId = values.attachments.persistentId||''
						}
						params = {
							id: this.state.twoId,
							bosUrl: !values.attachments?'':pic,
							name: values.name,
							md5Code: values.attachments&&(values.attachments[0]?.md5Code)?values.attachments[0].md5Code: '',
							fileName: !values.attachments?'':fileName,
							persistentId: persistentId,
							uploadUid: !values.attachments?'':values.attachments instanceof Array?values.attachments[0].uid:values.attachments.uid,
							uploadType: !values.attachments?'':values.attachments instanceof Array?values.attachments[0].type:values.attachments.type
						}
					}else {
						params = {
							id: this.state.twoId,
							bosUrl: '',
							name: values.name,
							fileName: '',
							persistentId: '',
							uploadUid: '',
							uploadType: ''
						}
					}
					
					console.log(params)
					axios.post('outlineController/update', params).then(res => {
						if (res.data.code === '200') {
							message.success('修改小节成功')
							_this.props.form.resetFields();
							_this.setState({ sectionVisible: false })
							_this.getoutlintList()
						} else {
							message.error(res.data.msg)
						}
					})
				}
			}

		});
	}
	
	getToken() {
		let _this = this;
		axios.get("/uplodController/get7menrToken").then((res) => {
			if (res.data.code === '200') {
				_this.setState({
					token: res.data.data.token,
					url: res.data.data.url
				})
			} else {
				message.error('七牛token获取失败')
			}

		}).catch((e) => {
			console.log(e)
		})
	}
	editlevel(item) {
		if (item.level === 1) {
			this.setState({ visible: true, modalTitle: '编辑章', oneName: item.name, oneId: item.id })
		}
		if (item.level === 2) {
			this.setState({
				sectionVisible: true,
				sectionTitle: '编辑小节',
				twoName: item.name,
				twoId: item.id,
				fileName: !item.fileName? '':item.fileName,
				bosUrl: !item.bosUrl?'':item.bosUrl,
				subjectIcon: !item.url?'':{
					url: item.url,
					name: item.fileName,
					type: item.uploadType,
					uid: item.uploadUid,
					persistentId: item.persistentId
				}
			})
		}
	}
	delOutline(item){
		Modal.confirm({
			title: `删除${item.level === 1 ? '章' : '小节' }`,
			okText: "确认",
			cancelText: "取消",
			content: (
				<div>
					<p >{`${item.level === 1 ?"大章删除后下属子节会跟随删除且不可恢复，请谨慎操作！确定要删除吗？": "子节删除后将不可恢复，请谨慎操作！确定要删除吗？"}`}</p>
				</div>
			),
			onOk: () => {
				axios.get(`outlineController/del/${item.id}`).then(res => {
					if(res.data.code === '200'){
						message.success('删除成功')
						this.getoutlintList()
					}else {
						message.error(res.data.msg)
					}
				})
			},
		});
		
	}
	
	getQiniuUrl = v => {
		// console.log(v)
	}
	render() {
		const { visible, modalTitle, oneName, subjectIcon, sectionVisible, catalogVisible, stageOption, courseOption, catalOption, sectionTitle, twoName } = this.state;
		const { getFieldDecorator } = this.props.form;
		const loop = data =>
			data.map(item => {
				if (item.children && item.children.length) {
					return (
						<TreeNode key={item.key} style={{ borderBottom: '1px solid #EBEBEB' }} title={(
							<div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
								<div>
									<span>{item.name}</span>
									<span style={{marginLeft: '20px'}}>{item.children&&item.children?`共${item.children.length}小节`:''}</span>
									{item.level===2&&item.url&&item.url?<span style={{marginLeft: '20px'}}>视频</span>: ''}
								</div>
								<div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
									{item.level === 1 ? <Button
										onClick={() => this.section(item)}
										type="primary"
										style={{ marginRight: '20px', fontSize: '12px', height: '28px', lineHeight: '28px', display: 'flex', alignItems: 'center', borderRadius: '4px' }}>新建子节</Button> : null}
									<Button type="primary" style={{ marginRight: '20px', fontSize: '12px', height: '28px', lineHeight: '28px', display: 'flex', alignItems: 'center' }}
										onClick={() => this.editlevel(item)}
									>编辑</Button>
									<Button type="danger" 
									onClick={()=>{
										this.delOutline(item)
									}}
									style={{ height: '28px', fontSize: '12px', display: 'flex', lineHeight: '28px', alignItems: 'center' }}>删除</Button>
								</div>
							</div>
						)}>
							{loop(item.children)}
						</TreeNode>
					);
				}
				return <TreeNode key={item.key} style={{ borderBottom: '1px solid #EBEBEB' }} title={(
					<div style={{ display: 'flex', justifyContent: 'space-between' }}>
						<div>
							<span>{item.name}</span>
							<span>{item.children&&item.children?`共${item.children.length}小节`:''}</span>
							{item.level===2&&item.url&&item.url?<span className='my-button-txt' style={{marginLeft: '20px',height: '25px',lineHeight: '25px',padding: '0 10px',fontSize:'12px'}}>视频</span>: ''}
						</div>
						
						<div style={{ display: 'flex', flexWrap: 'nowrap', alignItems: 'center' }}>
							{item.level === 1 ? <Button
								onClick={() => this.section(item)}
								type="primary"
								style={{ marginRight: '20px', fontSize: '12px', height: '28px', lineHeight: '28px', display: 'flex', alignItems: 'center', borderRadius: '4px' }}>新建子节</Button> : null}
							<Button type="primary" style={{ marginRight: '20px', fontSize: '12px', height: '28px', lineHeight: '28px', display: 'flex', alignItems: 'center' }}
								onClick={() => this.editlevel(item)}
							>编辑</Button>
							<Button type="danger" 
							onClick={()=>{
								this.delOutline(item)
							}}
							style={{ height: '28px', fontSize: '12px', display: 'flex', lineHeight: '28px', alignItems: 'center' }}>删除</Button>
						</div>
					</div>
				)}></TreeNode>;
			});

		return (
			<div className="catalogue">
				<div style={{ display: 'flex', justifyContent: 'space-between' }}>
					<span style={{ display: 'flex', alignItems: 'center', fontSize: '18px', fontWeight: '600' }}>课程目录</span>
					<span className="my-button-txt" onClick={() => {
						this.props.history.go(-1)
					}}>返回上一级</span>
				</div>

				<Divider />
				<div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '20px' }}>
					<h3>{this.state.statistics}</h3>
					<div>
						<Button className='my-button-primary mar-right' disabled={this.state.selectIds.length<=0?true:false} type='primary' onClick={() => {
							this.updateBatch({ visible: true })
						}}>批量操作</Button>
						<Button className='my-button-primary' type='primary' onClick={() => {
							this.setState({ visible: true })
						}}>新建章</Button>
					</div>
				</div>
				<Tree
					className="draggable-tree"
					defaultExpandedKeys={this.state.expandedKeys}
					checkable
					draggable
					blockNode
					onDragEnter={this.onDragEnter}
					onDrop={this.onDrop}
					onCheck={this.onCheck}
				>
					{loop(this.state.gData)}
				</Tree>
				{visible?<Modal
					getContainer={true}
					title={modalTitle}
					okText="确认"
					cancelText="取消"
					visible={visible}
					onOk={() => { this.handleOk() }}
					onCancel={() => { this.setState({ visible: false }) }}
					destroyOnClose
					maskClosable={false}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }} onSubmit={this.handleOk}>
						<Form.Item label={"章名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入章名称!', }],
								initialValue: modalTitle === '编辑章' ? oneName : ''
							})(
								<Input placeholder='请输入章名称' />
							)}
						</Form.Item>
					</Form>
				</Modal>:null}
				{sectionVisible ? <Modal
					getContainer={true}
					title={sectionTitle}
					okText="确认"
					cancelText="取消"
					visible={sectionVisible}
					onOk={() => { this.sectionOK() }}
					onCancel={() => { this.setState({ sectionVisible: false }) }}
					destroyOnClose
					maskClosable={false}
				>
					<Form labelCol={{ span: 5 }} wrapperCol={{ span: 17 }} onSubmit={() => this.sectionOK}>
						<Form.Item label={"小节名称"}>
							{getFieldDecorator('name', {
								rules: [{ required: true, message: '请输入小节名称!', }],
								initialValue: sectionTitle === '编辑小节' ? twoName : ''
							})(
								<Input placeholder='请输入小节名称' />
							)}
						</Form.Item>
						<Form.Item label="视频资源">
							{getFieldDecorator('attachments', {
								initialValue: sectionTitle === '编辑小节' ? subjectIcon : '',
								

							})(
								<UploadVideo checksType={'checke'} getQiniuUrl={this.getQiniuUrl}></UploadVideo>
							)}
						</Form.Item>
					</Form>
				</Modal> : null}
				{/* 更换层级 */}
				
				{catalogVisible?<Modal
					getContainer={true}
					title="批量更换资源"
					maskClosable={false}
					okText="确认"
					cancelText="取消"
					visible={catalogVisible}
					onOk={() => { this.submitOk() }}
					onCancel={() => { this.setState({ catalogVisible: false }) }}
					destroyOnClose
					width={600}
				>
					<Form labelCol={{ span: 4 }} wrapperCol={{ span: 20 }} onSubmit={this.handleOk}>
						<div style={{marginBottom:'20px'}}>将：<span style={{color:'red'}}>{this.state.parentOutlineNames}</span>下的 <span style={{color:'red'}}>{this.state.selectIds.length||0}</span> 小节更换到：</div>
						<Form.Item label="阶段名称" name="toStageId">
							{getFieldDecorator('toStageId', {rules: [
									{required: true,message: '请选择阶段名称'},
								]})(<Select onChange={this.stageChange}>
									{
										stageOption.map(v => {
											return <Option key={v.toStageId} value={v.toStageId}>{v.toStageName}</Option>
										})
									}
							</Select>)}
						</Form.Item>
						<Form.Item
							label="课程名称" name="toCourseId">
							{getFieldDecorator('toCourseId', {
								rules: [
									{required: true,message: '请选择课程名称'},
								],
							})(<Select onChange={this.courseChange}>
              {
                courseOption.map(v => {
                  return <Option key={v.courseId} value={v.courseId}>{v.courseName}</Option>
                })
              }
            </Select>)}
						</Form.Item>
						<Form.Item
							label="章名称" name="toOutlineId">
							{getFieldDecorator('toOutlineId', {
								rules: [
									{required: true,message: '请选择章名称'},
								],
							})(<Select onChange={(e) => {this.setState({toOutlineId: e})}}>
              {
                catalOption.map(v => {
                  return <Option key={v.oulineId} value={v.oulineId}>{v.oulineName}</Option>
                })
              }
            </Select>)}
						</Form.Item>
					</Form>
				</Modal>:null}
			</div>

		);
	}
}

export default Form.create()(Catalogue)